import { defaultDashboardPath } from "@dashboard/navigation/dashboardRoutes"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboardHost"
import { currentRequestHostname } from "@utils/dashboardHostRuntime"

export const Route = createFileRoute("/dashboard")({
  component: Outlet,
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })

    const normalizedPathname = location.pathname.replace(/\/+$/, "") || "/"
    if (normalizedPathname === "/dashboard") {
      throw redirect({ href: defaultDashboardPath })
    }
  },
})
